import React, { useEffect, useState } from 'react';
import Popup from './Popup';
import { getItem } from 'utils/local-storage';
import useSaveLead from 'hooks/useSaveLead';
import { ACCESS_TOKEN, USER_PROFILE } from 'utils/storage-keys';
import axios from 'axios';
import env from 'utils/env';
import { Button, message } from 'antd';
import { useGetUserProfileApi } from 'pages/dashboard/user/useUserApi';
import GlobalStore from 'stores/globalStore';

type Props = {
  membership: string;
  siteCode: string;
  country: string;
  money: number;
  setShowPopup: (state: boolean) => void;
};

const isPhoneValid = (number: string) => {
  return  /^(\+?[0-9]{8,12})$/.test(number);
};

const UpgradePopup: React.FC<Props> = ({
  membership,
  money,
  country,
  siteCode,
  setShowPopup
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [phoneValid, setPhoneValid] = useState(true);
  const [phone, setPhone] = useState('');
  const config = env();
  const token = getItem(ACCESS_TOKEN);
  const { profileObject } = useGetUserProfileApi();
  const { entitlements } = GlobalStore.useContainer();
  const userId = entitlements?.user_id || JSON.parse(getItem(USER_PROFILE) || "{}")?.user_id || '';
  const { saveLead } = useSaveLead();

  useEffect(() => {
    if (!token || !profileObject) return;
    if (!profileObject?.data?.username) {
      message.error('お名前を入力してください');
      return setShowPopup(false);
    }
    if (!isPhoneValid(profileObject?.data?.phone)) {
      return setPhoneValid(false);
    }

    saveLead(profileObject, membership, {}, {
      site_code: siteCode,
      unused_money: money,
      session_token: token,
      is_upgrade: true,
      user_id: userId,
      country
    });
  }, [membership, money, profileObject, siteCode, token, saveLead, userId, setShowPopup, country]);

  const handleSubmitPhone = async () => {
    if (!token) return;
    if (!isPhoneValid(phone))
      return message.error('正しい電話番号を入力してください');
    setIsLoading(true);
    try {
      await axios.patch(
        `${config.baseApiUrl}/user/api/v1/account`,
        {
          phone
        },
        {
          headers: {
            'X-Session-Token': token
          }
        }
      );

      const newProfile = {
        ...profileObject,
        data: { ...profileObject?.data, phone }
      }
      saveLead(newProfile, membership, {}, {
        site_code: siteCode,
        unused_money: money,
        session_token: token,
        is_upgrade: true,
        user_id: userId,
        country
      });
    } catch (error) {
      message.error('ただいま混み合っています。しばらくしてから再度お試しください。');
      setIsLoading(false);
    }
  };

  return (
    <Popup>
      {phoneValid ? (
        <h2>リクエストを処理しています...</h2>
      ) : (
        <div className="form-phone">
          <h3>お手続きを進めるため、電話番号を入力してください</h3>
          <div className="form-input">
            <label htmlFor="phone">電話番号</label>
            <input
              type="phone"
              name="phone"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <Button className="btn-primary" onClick={handleSubmitPhone} loading={isLoading}>
            登録する
          </Button>
          <button className="btn-white" onClick={() => setShowPopup(false)}>
            キャンセル
          </button>
        </div>
      )}
    </Popup>
  );
};

export default UpgradePopup;
